import { format, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import getDocumentList from './get-product-documents';
import checkDuplicateAtCart from './duplicate-address-at-cart';
import addProductWithOrderAttributes from './add-product-with-order-attributes';

export default async (
    product: SimpleProduct,
    restProps: any,
    propertyType: number,
    setError: React.Dispatch<React.SetStateAction<string>>,
    setShowLoader: React.Dispatch<React.SetStateAction<boolean>>
) => {
    setShowLoader(true);
    const docList = await getDocumentList(restProps, product!, '', propertyType, setError, () => {});
    if (docList) {
        //  setDocsList([...docList!]);
        let customAddress = {
            addressVerified: {},
            legalDescriptionCondoVerified: {},
            legalDescriptionVerified: {},
            lookForVerified: {},
            propertyType: propertyType,
            serviceAddress: {},
            sdab: {},
            lcsab: {},
            relatedProduct: [product],
            communityVerified: {},
            quadrantVerified: {},
            documentList: docList
        };
        const duplicateCheck = await checkDuplicateAtCart({}, restProps.context, product?.ItemId!, {
            documentId: (docList && docList[0].documentId!) || '',
            propertyType: propertyType,
            searchKey: ''
        });
        if (!duplicateCheck) {
            await addProductWithOrderAttributes([customAddress], restProps.context, () =>
                setError(restProps.resources.internalServerError)
            );
        } else {
            setError(format(restProps.resources.duplicateInCartErrorMessage, product?.Name));
        }
    }
    setShowLoader(false);
};
